<template>
    <div class="footer">
        <div class="container">
            <!-- 主要内容区域 -->
            <div class="footer-content">
                <!-- 左侧导航链接 -->
                <div class="nav-section">
                    <div class="nav-group">
                        <h3>关于我们</h3>
                        <ul>
                            <li @click="toPage('/about.html')">公司简介</li>
                            <li @click="toPage('/about.html')">资质奖项</li>
                        </ul>
                    </div>
                    <div class="nav-group">
                        <h3>解决方案</h3>
                        <ul>
                            <li @click="toPage('/monitor.html')">低空频谱监测平台</li>
                            <li @click="toPage('/mapping.html')">频谱测绘系统</li>
                            <li @click="toPage('/direction-finding.html')">非法辐射源定位系统</li>
                            <li @click="toPage('/fanwu.html')">牧星反无监测系统</li>
                            <li @click="toPage('/xingzhi-u1.html')">星智云盒U1</li>
                            <li @click="toPage('/uav.html')">抗干扰无人机系统</li>
                            <li @click="toPage('/ibos.html')">星筑IBOS系统</li>
                        </ul>
                    </div>
                    <div class="nav-group">
                        <h3>人力资源</h3>
                        <ul>
                            <li @click="toPage('/talent.html')">招聘职位</li>
                            <li @click="toPage('/talent.html')">人才理念</li>
                        </ul>
                    </div>
                    <div class="nav-group">
                        <h3>联系我们</h3>
                        <ul>
                            <li @click="toPage('/contactUs.html')">联系信息</li>
                        </ul>
                    </div>
                </div>

                <!-- 分隔线 -->
                <div class="divider"></div>

                <!-- 右侧联系信息 -->
                <div class="contact-section">
                    <!-- 二维码 -->
                    <div class="qrcode">
                        <img src="@/assets/dennis.png" alt="联系人二维码">
                        <p>扫码联系我们</p>
                    </div>
                    <div class="phone">
                        <img src="@/assets/linker.png" alt="联系人">
                        <span>联系人：丁先生</span>
                    </div>
<!--                    <div class="phone">-->
<!--                        <img src="@/assets/phone2.png" alt="手机">-->
<!--                        <span>手机：18951981008</span>-->
<!--                    </div>-->
                    <div class="phone">
                        <img src="@/assets/phone.png" alt="固话">
                        <span>固话：025-57660015</span>
                    </div>
                    <div class="phone">
                        <img src="@/assets/position.png" alt="地址">
                        <span>地址：南京市王桥路57号六合科创中心B座2F</span>
                    </div>
                </div>
            </div>

            <!-- 底部版权信息 -->
            <div class="copyright">
                <p>© 2024 <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2024062117号-1</a> 南京星谱智信息科技有限公司, ALL RIGHTS RESERVED.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MFooter2',
    methods: {
        toPage(path) {
            this.$router.push(path).catch(err => {})
        }
    }
}
</script>

<style scoped lang="less">
.footer {
    width: 100%;
    background-color: #444444;
    padding: 60px 0 40px;
    color: #ffffff;

    .container {
        max-width: 1280px;
        margin: 0 auto;
        padding: 0 20px;

        .footer-content {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            padding-bottom: 40px;
            margin-bottom: 20px;
            align-items: flex-start;

            .divider {
                width: 0;
                height: 200px;
                border-left: 1px solid #2E2E2E;
                border-right: 1px solid #707070;
                margin: 0 80px;
                align-self: flex-start;
                margin-top: 10px;
            }

            .nav-section {
                display: flex;
                gap: 80px;

                .nav-group {
                    h3 {
                        font-size: 16px;
                        font-weight: 500;
                        margin-bottom: 20px;
                        color: #ffffff;
                    }

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;

                        li {
                            font-size: 14px;
                            color: #D2D2D2;
                            margin-bottom: 12px;
                            cursor: pointer;
                            transition: color 0.3s;

                            &:hover {
                                color: #ffffff;
                            }
                        }
                    }
                }
            }

            .contact-section {
                .qrcode {
                    text-align: center;
                    margin-bottom: 30px;

                    img {
                        width: 120px;
                        height: 120px;
                        margin-bottom: 10px;
                    }

                    p {
                        color: #D2D2D2;
                        font-size: 14px;
                        margin: 0;
                    }
                }

                .phone, .address {
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;

                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 10px;
                    }

                    span {
                        color: #D2D2D2;
                        font-size: 14px;
                    }
                }
            }
        }

        .copyright {
            text-align: center;
            color: #D2D2D2;
            font-size: 14px;

            a {
                color: #D2D2D2;
                text-decoration: none;
                transition: color 0.3s;

                &:hover {
                    color: #ffffff;
                    text-decoration: underline;
                }
            }
        }
    }
}

// 移动端适配
@media (max-width: 1000px) {
    .footer {
        padding: 40px 0 30px;

        .container {
            padding: 0 20px;

            .footer-content {
                flex-direction: column;
                padding-bottom: 30px;

                // 移动端隐藏分隔线
                .divider {
                    display: none;
                }

                .nav-section {
                    flex-wrap: wrap;
                    gap: 40px;
                    margin-bottom: 30px;
                    justify-content: flex-start;

                    .nav-group {
                        width: 100%;
                        text-align: center;

                        h3 {
                            font-size: 16px;
                            margin-bottom: 15px;
                            position: relative;
                            display: inline-block;

                            &::after {
                                content: '';
                                position: absolute;
                                bottom: -5px;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 30px;
                                height: 2px;
                                background-color: rgba(255, 255, 255, 0.3);
                            }
                        }

                        ul li {
                            font-size: 14px;
                            margin-bottom: 12px;
                            padding: 8px 0;

                            &:active {
                                background-color: rgba(255, 255, 255, 0.1);
                            }
                        }
                    }
                }

                .contact-section {
                    text-align: center;
                    margin-top: 20px;
                    padding: 20px;
                    background-color: rgba(255, 255, 255, 0.05);
                    border-radius: 8px;

                    .qrcode {
                        margin-bottom: 30px;

                        img {
                            width: 140px;
                            height: 140px;
                        }

                        p {
                            font-size: 14px;
                            margin-top: 10px;
                        }
                    }

                    .phone, .address {
                        justify-content: center;
                        margin-bottom: 15px;
                        padding: 8px 0;

                        span {
                            font-size: 14px;
                        }

                        img {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }
            }

            .copyright {
                font-size: 13px;
                padding: 0 20px;
                line-height: 1.6;
            }
        }
    }
}
</style>
